export const taxLimitationListSelector = state =>
  state.getIn(['app', 'appraisal', 'exemption', 'taxLimitationList']);
export const applyToListSelector = state =>
  state.getIn(['app', 'appraisal', 'exemption', 'applytoList']);
export const taxingUnitValueTypesSelector = state =>
  state.getIn(['app', 'appraisal', 'exemption', 'taxingUnitValueTypes']);
export const taxingUnitListSelector = state =>
  state.getIn(['app', 'appraisal', 'exemption', 'taxingUnitList']);
export const applicationSelector = state =>
  state.getIn(['app', 'appraisal', 'exemption', 'application']);
export const segmentListSelector = state =>
  state.getIn(['app', 'appraisal', 'exemption', 'segmentList']);

// application lookup modal
export const applicationLookupModalOpenSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'exemption',
    'applicationLookupModal',
    'open',
  ]);
export const applicationLookupModalModeSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'exemption',
    'applicationLookupModal',
    'mode',
  ]);
export const applicationLookupModalPropertyIdSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'exemption',
    'applicationLookupModal',
    'propertyId',
  ]);
export const applicationLookupModalStateSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'exemption',
    'applicationLookupModal',
    'state',
  ]);
export const applicationLookupModalDataSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'exemption',
    'applicationLookupModal',
    'data',
  ]);
export const applicationLookupModalSelectionSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'exemption',
    'applicationLookupModal',
    'selection',
  ]);
